export const questionnaireZn = {
  questionnaire1: '提示',
  questionnaire2: '取消',
  questionnaire3: '确定',
  questionnaire4: '问卷已发生修改，请重新填写',
  questionnaire5: '提交',
  questionnaire6: '该问卷已停止收集',
  questionnaire7: '提交成功，感谢您的参与~',
  questionnaire8: '修改',
  questionnaire9: '单选',
  questionnaire10: '多选',
  questionnaire11: '填空',
  questionnaire12: '矩阵',
  questionnaire13: '打分',
  questionnaire14: '此题为必答题！',
  questionnaire15: '手机号格式不正确！'
}
export const questionnaireEn = {
  questionnaire1: 'Tip',
  questionnaire2: 'Cancel',
  questionnaire3: 'Confirm',
  questionnaire4: 'The questionnaire has been modified. Please fill it out again',
  questionnaire5: 'Submit',
  questionnaire6: 'The questionnaire has stopped collecting',
  questionnaire7: 'Submitted successfully, thank you for your participation~',
  questionnaire8: 'Modify',
  questionnaire9: 'Single choice',
  questionnaire10: 'Multiple choice',
  questionnaire11: 'Fill in the blank',
  questionnaire12: 'Matrix',
  questionnaire13: 'Marking question',
  questionnaire14: 'This question is mandatory！',
  questionnaire15: 'The format of the phone number is incorrect！'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/questionnaire/index.js